import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-up\"><defs><style>#icon-up .a{fill:#fff;stroke:#707070;}#icon-up .b{clip-path:url(#icon-up_a);}#icon-up .c{fill:none;stroke:#10a38b;stroke-linecap:round;stroke-linejoin:round;}</style><clipPath id=\"icon-up_a\"><rect class=\"a\" width=\"16\" height=\"16\" /></clipPath></defs><g class=\"b\"><path class=\"c\" d=\"M6,12,0,6,6,0\" transform=\"translate(14 4.5) rotate(90)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol